import { c as _c } from "react/compiler-runtime";
import { getButtonLinkProps } from '@openclassrooms/routing';
import Typography from '@classify/react-core-components/Typography';
import Hyperlink from '@classify/react-core-components/Hyperlink';
const MainHeaderNavigationLink = t0 => {
  const $ = _c(17);
  const {
    children: t1,
    className: t2,
    path: t3,
    content: t4,
    dataEvent: t5,
    variant: t6,
    dataTestId: t7,
    onClickAction: t8,
    linkAttributes: t9
  } = t0;
  const children = t1 === undefined ? null : t1;
  const className = t2 === undefined ? "" : t2;
  const path = t3 === undefined ? "" : t3;
  const content = t4 === undefined ? "" : t4;
  const dataEvent = t5 === undefined ? "" : t5;
  const variant = t6 === undefined ? "body" : t6;
  const dataTestId = t7 === undefined ? "" : t7;
  const onClickAction = t8 === undefined ? null : t8;
  let t10;
  if ($[0] !== t9) {
    t10 = t9 === undefined ? {} : t9;
    $[0] = t9;
    $[1] = t10;
  } else {
    t10 = $[1];
  }
  const linkAttributes = t10;
  let t11;
  if ($[2] !== path) {
    t11 = getButtonLinkProps(path);
    $[2] = path;
    $[3] = t11;
  } else {
    t11 = $[3];
  }
  const linkProps = t11;
  let t12;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      px: 0,
      py: 1,
      whiteSpace: "nowrap",
      "&:hover": {
        textDecoration: "none"
      }
    };
    $[4] = t12;
  } else {
    t12 = $[4];
  }
  let t13;
  if ($[5] !== children || $[6] !== content || $[7] !== variant) {
    t13 = content ? <Typography component="span" variant={variant}>{content}</Typography> : children;
    $[5] = children;
    $[6] = content;
    $[7] = variant;
    $[8] = t13;
  } else {
    t13 = $[8];
  }
  let t14;
  if ($[9] !== className || $[10] !== dataEvent || $[11] !== dataTestId || $[12] !== linkAttributes || $[13] !== linkProps || $[14] !== onClickAction || $[15] !== t13) {
    t14 = <Hyperlink {...linkProps} {...linkAttributes} className={className} data-event={dataEvent} data-testid={dataTestId} onClick={onClickAction} underline="none" color="secondary" sx={t12}>{t13}</Hyperlink>;
    $[9] = className;
    $[10] = dataEvent;
    $[11] = dataTestId;
    $[12] = linkAttributes;
    $[13] = linkProps;
    $[14] = onClickAction;
    $[15] = t13;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  return t14;
};
export default MainHeaderNavigationLink;